import { useState } from "react";
import { fetchContent } from "../../api/content";
import { fetchPathway } from "../../api/pathway";
import { ScreenState } from "../../components/ScreenState";
import { useSession } from "../../lib/session";
import { useAsync } from "../../lib/useAsync";
import { HubScreen } from "../../screens/hub/HubScreen";
import { Walkthrough } from "../../screens/walkthrough/Walkthrough";

export function HubRoute() {
  const { user } = useSession();
  const [replaying, setReplaying] = useState(false);
  const { data, loading, error, reload } = useAsync(
    () => Promise.all([fetchPathway(), fetchContent()]),
    [],
  );

  return (
    <ScreenState loading={loading} error={error} onRetry={reload}>
      {data && user?.track ? (
        <HubScreen
          {...data[0]}
          trackLabel={data[1].tracks[user.track].label}
          firstName={user.firstName}
          onWalkthrough={() => setReplaying(true)}
        />
      ) : null}
      {/* A voluntary replay: closable, and it never touches the account (the first finish is already recorded). */}
      {replaying ? (
        <Walkthrough
          required={false}
          onClose={() => setReplaying(false)}
          onFinish={() => setReplaying(false)}
        />
      ) : null}
    </ScreenState>
  );
}
